module.exports = __webpack_public_path__ + "img/fsa_hsa_eligible.dd0a2877.svg";